module.exports = __webpack_public_path__ + "static/media/ballot.1dba42dc.svg";